import { useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Global from '../../store/global-selectors';
import * as Actions from '../../store/csw/csw.actions';
import { doesServiceSupportSameDayFeature } from '../../hooks/use-is-service-local-delivery';

export const useCSWTypeId = (fulfillmentPlanId, initialCswTypeId, getNewCswTypeId) => {
  const cswTypeIdRef = useRef(initialCswTypeId);

  const dispatch = useDispatch();
  const sellerServices = useSelector(Global.selectSellerServices);

  const updateCSWTypeId = useCallback(
    (newShipFromId, externalFulfillmentProviderId, serviceId) => {
      const service = sellerServices.find((s) => s.serviceId === serviceId) || {};
      const isLocalDelivery = doesServiceSupportSameDayFeature(service);
      const newTypeId = getNewCswTypeId(fulfillmentPlanId, newShipFromId, externalFulfillmentProviderId, isLocalDelivery);
      if (newTypeId && newTypeId !== cswTypeIdRef.current) {
        cswTypeIdRef.current = newTypeId;
        dispatch(Actions.updateCSWType({ cswTypeId: newTypeId, fulfillmentPlanId }));
      }
      return newTypeId;
    },
    [dispatch, fulfillmentPlanId, getNewCswTypeId, sellerServices],
  );

  return {
    updateCSWTypeId,
  };
};
